import Loader from "react-loader-spinner";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { addOrUpdateModalDefinedServiceCosts, deleteDefinedServiceCost, getDefinedServiceCosts, getNextDefinedCode } from "../store/api/TaskDetailsApi";
import BihamtaTable from "../../Components/BihamtaTable";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckLg, DashCircle, ExclamationTriangle, List, Pencil, PencilFill, PlusSquare, Search } from "react-bootstrap-icons";
import { keyIsLetterOrNumber, setDialog, translateError } from "../../store/api/CommonFunctions";
import NewNumberInput from "../../Components/NewNumberInput";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAllProductTypesNew } from "../../store/api/GetAllProduct";

const ModalDefinedServiceCosts = (props) => {
    const [submitError, setSubmitError] = useState(null);
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const [popProduct, setPopProduct] = useState({ show: false });
    const [definedList, setDefinedList] = useState({ Data: [], TotlaCount: 0 });
    const [typeList, setTypeList] = useState([]);
    const filterData = useRef({});
    const [currentDef, setCurrentDef] = useState(null);
    const { show } = popData;
    const [showTypes, setShowTypes] = useState(false);
    const settingNames = ['ProductGrouppingType'];
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const pgType = Array.isArray(systemSettings ?? "") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;
    function close() {
        setCurrentDef(null);
        setPopData({ show: false });
        filterData.current = {};
    }
    function search() {
        filterData.current.Skip = 0;
        filterData.current.Take = 5;
        getDefinedServiceCosts(filterData.current, setDefinedList);
    }
    function onSubmit() {
        setSubmitError(null);
        if ((currentDef.ItemCode ?? "") === "") {
            setSubmitError("کد تعرفه وارد نشده است");
            return;
        }
        if ((currentDef.ItemDesc ?? "") === "") {
            setSubmitError("شرح تعرفه وارد نشده است");
            return;
        }
        if ((currentDef.ItemCost ?? "") === "") {
            setSubmitError("هزینه خدمات مشخص نشده است");
            return;
        }
        const onAddUpdate = (res) => {
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else if (res.Data) {
                filterData.current = { Skip: 0, Take: 5 };
                setCurrentDef(null);
                setDefinedList(res);
            }
        }
        if (currentDef.e) {
            delete currentDef.e;
        }
        addOrUpdateModalDefinedServiceCosts(currentDef, onAddUpdate);
    }
    function showHideTypes(show) {
        if (show && !(typeList?.length > 0)) {
            getAllProductTypesNew(setTypeList);
        }
        setShowTypes(show);
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "کد تعرفه", colName: "ItemCode", justInMobile: true },
        { colTitle: "شرح تعرفه", colName: "ItemDesc", justInMobile: true },
        { colTitle: "هزینه خدمات", colName: "ItemCost", colType: "currency" },
        { colTitle: "محصول مرتبط", colName: "ProductName" }
    ]
    const rowButtons = [
        { type: "common", title: "ویرایش تعرفه", icon: <PencilFill color="orange" size={18} />, onclick: setForEdit },
        {
            title: "حذف تعرفه", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف تعرفه',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteDefinedServiceCost(item.ID, onDelete)
                }))
            }
        }
    ];
    const onDelete = (res) => {
        if (res.Error) {
            setSubmitError(translateError(res.Error));
        }
        else if (res.Data) {
            setDefinedList(res);
        }
    }
    function setForEdit(row) {
        if (currentDef) {
            return;
        }
        setCurrentDef(row);
        setShowTypes(Number(row.ProductTypeID) > 0);
    }
    function setForAdd() {
        const onGetCode = (res) => {
            if (res.Data) {
                setCurrentDef({ ID: 0, ItemCode: res.Data });
            }
            else if (res.Error) {
                setCurrentDef({ ID: 0 });
            }
        }
        getNextDefinedCode(onGetCode)
    }
    function cancel() {
        setCurrentDef(null);
        setShowTypes(false);
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setCurrentDef({ ...currentDef, ProductName: data.ProductName + "-" + data.ProductModel, RelatedProductHardCode: data.ProductHardCode, RelatedProductName: data.ProductName });
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
    }
    useEffect(() => {
        if (show) {
            getSystemSettings(settingNames);
            filterData.current = { Skip: 0, Take: 5 };
            getDefinedServiceCosts(filterData.current, setDefinedList);
            setShowTypes(false);
        }
    }, [show])
    return (
        <Modal size="lg" show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    خدمات و تعرفه ها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} />
                {currentDef &&
                    <Row className="rowBorder">
                        {pgType !== 1 &&
                            <div className="rowTitle">
                                <input type="checkbox" className="form-check-input" onChange={e => showHideTypes(e.target.checked)} defaultChecked={Number(currentDef.ProductTypeID) > 0} />&nbsp; ثبت برحسب نوع محصول
                            </div>
                        }
                        <Col className="form-group" md={2}>
                            <label>کد تعرفه: </label>
                            <Form.Control defaultValue={currentDef.ItemCode ?? ""} onChange={e => currentDef.ItemCode = e.target.value} />
                        </Col>
                        <Col className="form-group" md={4}>
                            <label>شرح تعرفه: </label>
                            <Form.Control defaultValue={currentDef.ItemDesc ?? ""} onChange={e => currentDef.ItemDesc = e.target.value} />
                        </Col>
                        <Col className="form-group" md={6}>
                            <label>توضیحات بیشتر: </label>
                            <Form.Control defaultValue={currentDef.ItemLongDesc ?? ""} onChange={e => currentDef.ItemLongDesc = e.target.value} />
                        </Col>
                        {showTypes ?
                            <Col className="form-group" md={6}>
                                <label>نوع محصول: </label>
                                {typeList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {typeList && Array.isArray(typeList) &&
                                    <select className="form-control" defaultValue={currentDef.ProductTypeID ?? ""} onChange={e => currentDef.ProductTypeID = e.target.value}>
                                        <option value="">انتخاب کنید</option>
                                        {typeList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col> :
                            <Col className="form-group" md={6}>
                                <label>محصول مرتبط: </label>
                                <Form.Control value={currentDef.ProductName ?? ""} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalProduct}><List size={21} /></Button>
                            </Col>
                        }
                        <Col className="form-group" md={3}>
                            <label>هزینه خدمات: </label>
                            <NewNumberInput defaultValue={currentDef.ItemCost ?? ""} onChange={e => currentDef.ItemCost = e.target.value} />
                        </Col>
                        <Col md={12} className="form-group" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px" }}>
                            <Button variant="info" className="group-Btn" onClick={onSubmit}>
                                {Number(currentDef.ID) > 0 &&
                                    <Fragment>
                                        <Pencil size={16} />&nbsp; ویرایش تعرفه
                                    </Fragment>
                                }
                                {Number(currentDef.ID) === 0 &&
                                    <Fragment>
                                        <CheckLg size={16} />&nbsp; ثبت تعرفه
                                    </Fragment>
                                }
                            </Button>
                            <Button variant="danger" className="group-Btn" onClick={cancel}><DashCircle size={17} />&nbsp; انصراف</Button>
                        </Col>
                    </Row>
                }
                {!currentDef &&
                    <Row className="rowBorder">
                        <Col md={3} className="form-group">
                            <label>کد تعرفه: </label>
                            <Form.Control onChange={e => filterData.current.ItemCode = e.target.value} />
                        </Col>
                        <Col md={3} className="form-group">
                            <label>شرح تعرفه: </label>
                            <Form.Control onChange={e => filterData.current.ItemDesc = e.target.value} />
                        </Col>
                        <Col md={3} className="form-group">
                            <label>محصول مرتبط: </label>
                            <Form.Control onChange={e => filterData.current.RelatedProductName = e.target.value} />
                        </Col>
                        <Col md={3} className="from-group" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px" }}>
                            <Button className="group-Btn" onClick={search}><Search size={17} />&nbsp; جستجوی تعرفه</Button>
                        </Col>
                    </Row>
                }
                {submitError && <Alert variant="danger" style={{ width: "90%", margin: "auto", marginTop: "5px" }}>
                    <ExclamationTriangle size={18} />&nbsp;
                    {submitError}
                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setSubmitError(null)} style={{ float: "left" }} />
                </Alert>}
                {!currentDef &&
                    <Fragment>
                        <Button variant="info" className="group-Btn mt-1" onClick={setForAdd}><PlusSquare size={20} /></Button>
                        <BihamtaTable columns={tableCols} filterData={filterData.current} rowButtons={rowButtons} searchMethod={getDefinedServiceCosts} dataList={definedList} hasPaging={true} />
                    </Fragment>
                }
            </Modal.Body>
        </Modal>
    )

}
export default ModalDefinedServiceCosts;